import React, { useEffect, useState } from "react";

import {
  Row,
  Input,
  Typography,
  Form,
  Col,
  DatePicker,
  InputNumber,
  Divider,
  Avatar,
  Select,
  Card,
  Spin,
} from "antd";
import { Medal, UserRound } from "lucide-react";

import { FONT } from "constants/index";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { ColumnsUserRecord } from "./columns-table";
import useBreakpoint from "hooks/useBreakpoint";
import ResponsiveDataList from "components/responsive-data-list";

dayjs.extend(customParseFormat);

const { Text } = Typography;
const { Option } = Select;
const dateFormat = "DD/MM/YYYY";

const FormNewRecord = (props) => {
  const { isMobile, isTablet, isDesktop } = useBreakpoint();
  const [data, setDataDrawer] = useState([]);
  const [imgAvatar, setImgAvatar] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const avatarSize = isDesktop ? 120 : isTablet ? 88 : 72;

  useEffect(() => {
    setImgAvatar(props.imgAvatar);
    setLoadingData(props.loading);
    setDataDrawer(props.dataDrawer);
  }, [props]);
  return (
    <>
      <Spin spinning={loadingData}>
        <Form
          ref={props.formRef}
          layout="vertical"
          requiredMark={false}
          className="reviews-comparation-form"
        >
          <Row
            gutter={16}
            style={{ textAlign: "center", marginBottom: isDesktop ? 30 : 16 }}
          >
            <Col span={24}>
              <Avatar
                src={imgAvatar}
                icon={<UserRound size={avatarSize} />}
                size={avatarSize}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="reviews-form-grid">
            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label={<span style={{ fontFamily: FONT }}>Aluno</span>}
              >
                <Input
                  disabled={true}
                  style={{ fontFamily: FONT, width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="date"
                label={<span style={{ fontFamily: FONT }}>Data</span>}
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a data da avaliação",
                  },
                ]}
              >
                <DatePicker
                  style={{ fontFamily: FONT, width: "100%" }}
                  placeholder={["", ""]}
                  format={dateFormat}
                  suffixIcon={null}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="typeRecord"
                label={<span style={{ fontFamily: FONT }}>Tipo</span>}
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o tipo do recorde",
                  },
                ]}
              >
                <Select allowClear style={{ fontFamily: FONT, width: "100%" }}>
                  <Option value="SPRINT_LINEAR">Sprint Linear</Option>
                  <Option value="COD_SPRINT">Cod Sprint</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="record"
                label={<span style={{ fontFamily: FONT }}>Resultado</span>}
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o resultado do aluno",
                  },
                ]}
              >
                <InputNumber
                  decimalSeparator=","
                  style={{ fontFamily: FONT, width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider />

          <Row gutter={16} style={{ marginTop: "15px" }}>
            <Col span={24}>
              <Card
                id="card-table"
                className="card-table-list"
                title={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Medal
                        size={18}
                        style={{ marginBottom: "-4px", marginRight: "10px" }}
                      />
                      <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                        Histórico de Sprints
                      </Text>
                    </div>
                  </div>
                }
                bordered={false}
              >
                <ResponsiveDataList
                  isMobile={isMobile}
                  forceCardLayout={!isDesktop}
                  cardVariant={!isDesktop ? "history" : undefined}
                  rowKey="id"
                  columns={ColumnsUserRecord()}
                  dataSource={data}
                  pagination={{ pageSize: 3, showSizeChanger: false }}
                  locale={{
                    emptyText: "Sem registro",
                  }}
                />
              </Card>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
export default FormNewRecord;
